<template>
  <div>
    <div class="simple cx_style">
      <!-- 字体 -->
      <div class="content mb8 verticallyCenter">
        <div class="content-item mr8">
          <el-select style="width: 126px; height: 32px" v-model="configData.fontFamily">
            <el-option v-for="(item, index) in fontFamilyList" :key="index" :label="item.label" :value="item.value">
              {{ item.label }}
            </el-option>
          </el-select>
        </div>
        <div class="content-item flex1">
          <div class="font-arrangement-btn multiple">
            <el-tooltip
              v-for="(item, index) in fontStyleList"
              :key="index"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span :class="isActive(index) ? 'select pd1' : 'pd1'" @click="changeStyle(index, isActive(index), '')"
                ><i :class="item._class"></i
              ></span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="verticallyCenter mb8 set-item-28">
        <el-select v-model="configData.fontWeight" class="mr8 content-item">
          <el-option
            v-for="(item, index) in fontWeightList"
            :key="index"
            :selected="configData.fontWeight == item.value"
            :value="item.value"
            :label="item.title"
          >
          </el-option>
        </el-select>
        <div class="number-input-box">
          <single-input
            class="percent100"
            :value.sync="configData.fontSize"
            inputSuffixs="px"
          />
        </div>
      </div>
      <!--字重和字号 -->
    </div>
    <div class="setting-item clearFloat mb8 set-item-28">
      <div class="content verticallyCenter">
        <div class="content-item floatLeft mr8 cx_style">
          <!-- 行高和字间距木有百分比之说 -->
          <single-input
            :value.sync="configData.lineHeight"
            inputSuffixs="px"
            placeholder="请输入"
          />
          <p class="fs12 mt8 ml12 setting-item-txt">行高</p>
        </div>
        <div class="content-item floatLeft cx_style">
          <!-- 行高和字间距木有百分比之说 -->
          <single-input
            :value.sync="configData.letterSpacing"
            inputSuffixs="px"
            placeholder="请输入"
          />
          <p class="fs12 mt8 ml12 setting-item-txt">字间距</p>
        </div>
      </div>
    </div>
    <div v-show="showTextAlignSetting" class="setting-item clearFloat  mb8 set-item-28">
      <div class="content clearFloat">
        <div class="content-item floatLeft" style="width: 100%">
          <div ref="component" class="font-arrangement-btn">
            <span class="btn-active" :style="getTranslate"></span>
            <el-tooltip
              v-for="(val, index) in arrangementList"
              :key="index"
              :class="['item', hideHighLevelSetting && val.type === 'highLevel' ? 'disabled' : '']"
              effect="dark"
              :content="val.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                :key="index"
                :class="activeArrangement == val.value ? 'select pd2' : 'pd2'"
                @click="changeArrangement(val, '')"
                ><i :class="val.className"></i
              ></span>
            </el-tooltip>
            <el-tooltip
              :class="['item', hideHighLevelSetting ? 'disabled' : '']"
              effect="dark"
              :content="activeArrangementOrder.label"
              placement="top-end"
            >
              <span
                :class="
                  activeArrangementOrder.isActive
                    ? activeArrangementOrder._class + ' select pd2'
                    : activeArrangementOrder._class
                "
                @click="changeArrangementOrder(activeArrangementOrder.isActive, '')"
              ></span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="verticallyCenter">
      <span class="fs14 mr16 keep-all">文字颜色</span>
      <cx-color-picker class="width-72"  :config.sync="configData.fontColor">
      </cx-color-picker>
    </div>
  </div>
</template>

<script>
import { getDiffVal } from "utils/index"
import "@/modules/common.css"
import publicData from "@/modules/mixins/publicData.js"
import cxColorPicker from "./cxColorPicker.vue"
import complexSetMixin from "./complexSetMixin.js"
export default {
  components: {
    cxColorPicker
  },
  mixins: [publicData, complexSetMixin()],
  name: "textSettingComplex",
  props: {
    defaultValue: Object,
    config: {
      type: Object,
      default: () => {}
    },
    showTextAlignSetting: {
      type: Boolean,
      default: true
    },
    hideHighLevelSetting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // configData: Object.assign({}, this.defaultValue, this.config),
      fontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false,
          label: "加粗"
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false,
          label: "斜体"
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false,
          label: "下划线"
        }
      ],
      fontFamilyList: [
        {
          label: "默认字体",
          value: "sans-serif"
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体"
        },
        {
          label: "方正",
          value: "方正"
        },
        {
          label: "方正正大黑简体",
          value: "方正正大黑简体"
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体"
        },
        {
          label: "庞门正道标题",
          value: "庞门正道标题"
        },
        {
          label: "思源黑体",
          value: "SourceHanSansCN"
        },
        {
          label: "思源宋体",
          value: "SourceHanSerifCN"
        },
        {
          label: "优设标题黑",
          value: "YouSheBiaoTiHei"
        },
        {
          label: "Alata",
          value: "Alata"
        },
        {
          label: "D-din",
          value: "D-din"
        },
        {
          label: "D-din Condensed",
          value: "D-din Condensed"
        },
        {
          label: "D-din Exp",
          value: "D-din Exp"
        },
        {
          label: "Raleway",
          value: "Raleway"
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular"
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black"
        }
      ],
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 600
        },
        {
          title: "加粗体",
          value: 900
        }
      ],
      arrangementList: [
        {
          label: "左对齐",
          className: "icon-portal-text-leftt1",
          value: "left"
        },
        {
          label: "居中对齐",
          className: "icon-portal-text-center1",
          value: "center"
        },
        {
          label: "右对齐",
          className: "icon-portal-text-right1",
          value: "right"
        },
        {
          label: "两端对齐",
          className: "icon-portal-text-both1",
          value: "justify",
          type: "highLevel"
        }
      ],
      translate: 0,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      sliderWidth: 0
    }
  },
  mounted() {
    this.fontStyleList[0].isActive = parseInt(this.configData?.fontWeight) > 500 ? true : false
    this.fontStyleList[1].isActive = this.configData?.fontStyle === "normal" ? false : true
    this.fontStyleList[2].isActive = this.configData?.textDecoration === "none" ? false : true
    const width = this.$refs.component.clientWidth
    this.sliderWidth = parseInt((width - 6) / 5)
    this.fontSizeVal = this.originFontSizeVal
  },
  watch: {
    'configData.fontWeight': function(val) {
      this.fontStyleList[0].isActive = parseInt(val) > 500 ? true : false
    },
    // 'configData.fontStyle': (val) => {
    //   const newValue = val == "normal" ? false : true;
    //   this.fontStyleList[1].isActive = newValue
    // },
    // 'configData.textDecoration': (val) => {
    //   this.fontStyleList[2].isActive = val == "none" ? false : true
    // }   
  },
  computed: {
    isActive(index) {
      return (index) => {
        if (index === 0 ) {
          return this.configData?.fontWeight == 600
        }
        if (index === 1) {
          return this.configData?.fontStyle == "italic"
        }
        if (index === 2) {
          return this.configData?.textDecoration === "underline"
        }
      }
    },
    activeArrangement() {
      let index = this.arrangementList.findIndex(item => item.value === this.configData.textAlign)
      // 44.4 一个滑块的宽度
      this.translate = this.sliderWidth * index
      return this.configData.textAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingModeVal = val
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
  },
  methods: {
    changeStyle(flag, temp, hoverFlag) {
      let curFontStyleList = hoverFlag ? "hoverFontStyleList" : "fontStyleList"
      switch (flag) {
        case 0:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.configData.fontWeight = 400
          } else {
            this[curFontStyleList][flag].isActive = true
            this.configData.fontWeight = 600
          }
          break
        case 1:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.configData.fontStyle = "normal"
          } else {
            this[curFontStyleList][flag].isActive = true
            this.configData.fontStyle = "italic"
          }
          break
        case 2:
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this.configData.textDecoration = "none"
          } else {
            this[curFontStyleList][flag].isActive = true
            this.configData.textDecoration = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      if (this.hideHighLevelSetting && val.type === "highLevel") {
        return
      }
      this.configData.textAlign = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      if (this.hideHighLevelSetting) {
        return
      }
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        this.configData.writingMode = "horizontal-tb"
      } else {
        this[curActiveArrangementOrder].isActive = true
        this.configData.writingMode = "vertical-lr"
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    lineHeightHandleCommand(val) {
      if (this.configData.lineHeightType === val) {
        return
      }
      this.configData.lineHeightType = val
      this.configData.lineHeight = val === "%" ? 100 : 34
    },
    letterSpacingHandleCommand(val) {
      if (this.configData.letterSpacingType === val) {
        return
      }
      this.configData.letterSpacingType = val
      this.configData.letterSpacing = val === "%" ? 1 : 0
    }
  }
}
</script>

<style scoped>
.ml12 {
  margin-left: 12px;
}
.setting-item-txt {
  color: var(--collapsibleItemContentTextColor);
}
.set-item-28/deep/ .el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 4px 0 4px 12px;
}
.set-item-28/deep/ .el-select .el-input__suffix-inner {
  line-height: 28px;
}
.set-item-28/deep/ .number-input-box .suffix_text {
  line-height: 28px;
}

.set-item-28/deep/ .el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}
.set-item-28/deep/ .suffix_text {
  line-height: 28px;
}
.set-item-28/deep/ .el-input-group__append .icon-arrows-bg {
  height: 13px;
}
.font-arrangement-btn span:hover::before {
  color: var(--collapsibleItemContentTextColor);
}
.cx_style/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
.el-input__inner:active {
  border: 1px solid var(--themeColor) !important;
}
.font-arrangement-btn span {
  width: calc(100% / 5);
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 5);
}
.font-arrangement-btn.multiple span.select {
  background: var(--leftMenuBgColor);
}
.multiple span:first-child::after {
  display: none;
}
.multiple span:nth-child(2)::after {
  display: block;
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -28px !important;
}
.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 2px 0;
  display: inline-block;
  vertical-align: top;
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
::v-deep .el-tooltip.disabled {
  cursor: not-allowed;
}
</style>
